import * as Yup from "yup";
import { object } from "yup";
import { TaxFillingStatusEnum } from "enums";
import { validation } from "formUtils/validation";
import i18n from "i18n";

export const taxFillingMemberShape = {
  id: validation.stringRequired,
  name: validation.stringRequired,
  taxFillingStatus: validation.stringRequired,
  isMarriedFilingJointly: Yup.boolean().when("taxFillingStatus", {
    is: (v: string) => v === i18n.t("filer"),
    then: () => validation.booleanRequired,
    otherwise: () => validation.booleanNotRequired,
  }),
  claimantOfDependent: Yup.string().when("taxFillingStatus", {
    is: (v: string) => v === i18n.t("dependent"),
    then: () => validation.stringRequired,
    otherwise: () => validation.stringNotRequired,
  }),
  outsideHouseholdTaxDependent: validation.booleanRequired,
  isClaimedByNoncustodialParent: validation.booleanRequired,
};

export const validationSchema = Yup.object().shape({
  taxFillingMembers: Yup.array().of(object().shape(taxFillingMemberShape)),
});

export const taxFillingStatusOptions = [
  { uuid: TaxFillingStatusEnum.FILER, name: TaxFillingStatusEnum.FILER },
  {
    uuid: TaxFillingStatusEnum.DEPENDENT,
    name: TaxFillingStatusEnum.DEPENDENT,
  },
  {
    uuid: TaxFillingStatusEnum.NON_FILER,
    name: TaxFillingStatusEnum.NON_FILER,
  },
];

export const yesNoOptions = [
  { label: "yes", value: true },
  { label: "no", value: false },
];
